import React from 'react';
import AppDetailPage from '../../features/apps/components/AppDetailPage';

/**
 * Unauthenticated app detail page for the landing/store flow.
 * Same design as inside: Start → login, Back to store → home (landing store).
 */
const StoreAppDetailRoute = () => {
  return <AppDetailPage fromLanding={true} />;
};

export default StoreAppDetailRoute;
